import React from "react";
import "./DashboardHeader.css";

export default function DashboardHeader() {
  return <div className="dashboardHeader">DashboardHeader</div>;
}
